import styles from "./Item.module.css";
import { calculateRemainingTime, timeAgo } from "../../../../base/utils";
import {
  _remove_notification,
  _set_seen,
} from "../../../../store/actions/notification_actions";
// import FlipDownCounter from "./FlipDownCounter";
import CircleDownCounter from "./CircleDownCounter";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { API } from "../../../../request/api";
import { useTranslation } from "react-i18next";

const Item = ({
  id,
  send_time,
  subject,
  message,
  expires_in,
  seen,
  image,
  is_expired,
}) => {
  const [_searchParams, setSearchParams] = useSearchParams();
  const {
    Login: { is_login },
  } = useSelector((state) => state);

  const { i18n, t } = useTranslation();

  const dispatch = useDispatch();

  const countDown = expires_in
    ? calculateRemainingTime(send_time, expires_in)
    : null;

  const openDetailHandler = (id, seen) => {
    if (!seen) {
      if (is_login) {
        API.post.seenNotification(id).finally(() => {
          dispatch(_set_seen(id));
        });
      } else {
        dispatch(_set_seen(id));
      }
    }
    setSearchParams(
      { id },
      {
        replace: true,
      }
    );
  };

  return (
    <div
      onClick={() => openDetailHandler(id, seen)}
      className={`${styles.notification}  ${
        is_expired ? styles.expiredItem : !seen ? styles.unSeen : ""
      }`}
    >
      <div
        className={`${styles.contentContainer} ${countDown ? styles.ContentContainerWithTimer : ''}`}>
        {/* {!seen && (
          <div className={styles.unSeenIconContainer}>
            <div className={styles.unSeenIcon}></div>
          </div>
        )} */}
          <div className={styles.content}>
          <div className={styles.ItemHeader}>
          <div className={styles.ItemHeaderTitle}>
              <span className={is_expired ? styles.statusDotExpired : styles.statusDotActive} />
              <p className={styles.itemTitle}>
                {subject}
                {is_expired ? ` ${t('notifications.expired')}` : ''}
              </p>
            </div>
            {!countDown && (
              <div className={styles.CountDownContainer}>
                {expires_in === null ? (
                  <div className={styles.expireDate}> {timeAgo(send_time, i18n.language)}</div>
                ) : null}
              </div>
            )}
          </div>
          {message ? (
            <div
              className={`${styles.message} ${
                i18n.dir() === 'rtl' ? styles.messageRtl : styles.messageLtr
              }`}
              dangerouslySetInnerHTML={{
                __html: message
              }}
            />
          ) : null}
        </div>
        {countDown && (
          <div className={styles.TimerContainer}>
            <CircleDownCounter
              onExpired={() => {
                dispatch(_remove_notification(id));
              }}
              initialSeconds={countDown}
            />
          </div>
        )}
      </div>
      {image && (
        <div>
          <img
            className={styles.notificationImg}
            src={process.env.REACT_APP_API_URL_REST + image}
            alt=""
          />
        </div>
      )}
    </div>
  );
};

export default Item;
